/**
 * @author       luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Similar listings experiment hook
 */
import { OptimizelyContext, type ReactSDKClient } from '@optimizely/react-sdk'
import { BetaFeature, isBetaFeatureEnabled } from '@zcode/nr-utils'
import type { Location } from 'history'
import { useContext } from 'react'
import { useLocation } from 'react-router-dom'
const VARIATION = 'WEB_DETAIL_MRR_SIMILAR_LISTINGS'

const hasBetaFlag = (location: Location) =>
  isBetaFeatureEnabled(location, BetaFeature.SIMILAR_LISTINGS)

export const isSimilarListingsExperiment = (
  optimizely: ReactSDKClient | null,
  location?: Location
) => {
  return (location && hasBetaFlag(location)) || optimizely?.activate(VARIATION) === 'TEST'
}

export const useIsSimilarListingExperiment = () => {
  const { optimizely } = useContext(OptimizelyContext)
  const location = useLocation()
  return hasBetaFlag(location) || optimizely?.getVariation(VARIATION) === 'TEST'
}
